<template>
  <div>
    <div class="row text-white inner-row" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.baseTSR.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Базовое ТСР'" :value="fieldView(object.baseTSR.name)"></simple-row>
    <simple-row :name="'Категория инвалидности'" :value="fieldView(object.disabledCategory.name)"></simple-row>
    <simple-row :name="'Сумма компенсации'" :value="object.limit && object.limit.length > 0 ? fieldView(object.limit[0].value) : '-'"></simple-row>
    <simple-row :name="'Начало действия'" :value="object.limit && object.limit.length > 0 ? convertDate(object.limit[0].startDate) : '-'"></simple-row>

    <div class="table-responsive text-left">
      <table class="table bg-white">
        <thead :class="theadClasses">
        <tr>
          <slot name="columns">
            <th> Начало действия </th>
            <th> Сумма </th>
          </slot>
        </tr>
        </thead>
        <tbody v-if="object.limit.length > 0">
        <tr v-for="(item, index) in object.limit" :key="index">
          <td>
            {{itemValue(item, 'startDate')}}
          </td>
          <td>
            {{itemValue(item, 'value')}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {getValueByField, longAsStringDate} from "@/services/utils";
 import {convertLongToPeriod} from "@/services/periods-service";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showCalls: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     itemValue(item, column) {
       let value = this.getValue(item, column);
       if (value) {
         if (column.toLowerCase().includes("date") || column.toLowerCase().includes("time")) {
           return longAsStringDate(value);
         } else {
           return value;
         }
       } else {
         return "-"
       }
     },
     getValue(item, column) {
       return item ? getValueByField(item, column) : '-';
     }
   }
 }
</script>
<style>
</style>
